<template>
    <div class="flex items-center space-x-2 border-b my-6 py-1 text-gray-600 dark:text-gray-400 dark:border-dark-700">
        <div>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
            </svg>
        </div>
        <div v-html="nomeDoDia" class="text-sm font-bold"></div>
    </div>
</template>

<script>
import { nomeDoDiaDaSemana, nomeDoMês, utcParaLocal, pad } from '@Shared/Date'

export default {
    props: ['timestamp'],
    computed: {
        nomeDoDia() {
            let date = utcParaLocal(this.timestamp)

            return nomeDoDiaDaSemana(date) + ', ' + pad(date.getDate()) + ' de ' + nomeDoMês(date)
        },
    },
}
</script>